module.exports = __webpack_public_path__ + "static/legion_loyalty_2_mtg_clb-86e8ff9b1ab9151eabf7a0c1c9233e3f.webp";